import { Badge, Text } from '@change/ds-core-ui';

import copiedLinkIcon from 'src/assets/starterDashboardV2/readyToShare/copiedLinkIcon.svg';
import copyLinkIcon from 'src/assets/starterDashboardV2/readyToShare/copyLinkIcon.svg';
import linkBioIcon from 'src/assets/starterDashboardV2/readyToShare/linkBioIcon.svg';
import linkStickerIcon from 'src/assets/starterDashboardV2/readyToShare/linkStickerIcon.png';
import pasteIcon from 'src/assets/starterDashboardV2/readyToShare/pasteIcon.svg';
import pasteUrlIcon from 'src/assets/starterDashboardV2/readyToShare/pasteUrlIcon.png';
import stickerIcon from 'src/assets/starterDashboardV2/readyToShare/stickerIcon.png';

import { thumbnailStyles } from './Step.styles';

export type StepVariant =
	| 'sticker_icon'
	| 'copied_link'
	| 'copy_link'
	| 'paste'
	| 'paste_url'
	| 'link_in_bio'
	| 'link_sticker';

type Props = {
	stepLabel: string;
	label: string;
	variant: StepVariant;
};

const stepThumbnails: Record<StepVariant, string> = {
	copied_link: copiedLinkIcon,
	copy_link: copyLinkIcon,
	link_in_bio: linkBioIcon,
	link_sticker: linkStickerIcon,
	paste: pasteIcon,
	paste_url: pasteUrlIcon,
	sticker_icon: stickerIcon,
};

export function Step({ variant, stepLabel, label }: Props) {
	return (
		<div className="stroke-weaker rounded-large flex h-[88px] w-full grow flex-row gap-4 overflow-hidden border">
			<div className="stroke-weaker bg-background-overlay flex h-full w-[72px] shrink-0 items-center justify-center border-r">
				<img
					data-testid="step-thumbnail"
					src={stepThumbnails[variant]}
					alt={`Step thumbnail: ${stepLabel}`}
					className={thumbnailStyles({ variant })}
				/>
			</div>
			<div className="flex grow flex-col items-start justify-center gap-2 pr-3">
				<Badge size="small" variant="information" label={stepLabel} emphasis="weaker" />
				<Text className="text-size-body md:text-size-body-large">{label}</Text>
			</div>
		</div>
	);
}
